import { Mapper } from '../../../../../base/utils/mapper';
import { OfficesModel } from '../../../../../domain/models/configuration/company/offices.model';
import { OfficesEntity } from '../../entities/company/offices.entity';

export class OfficesImplementationRepositoryMapper extends Mapper<
  OfficesEntity,
  OfficesModel
> {
  mapFrom(param: OfficesEntity): OfficesModel {
    return {
      data: param.data,
      isSuccess: param.isSuccess,
      message: param.message,
      errors: param.errors,
    };
  }
  mapTo(param: OfficesModel): OfficesEntity {
    return {
      data: param.data,
      isSuccess: param.isSuccess,
      message: param.message,
      errors: param.errors,
    };
  }
}
